import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-sante-professionnels',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-sante-professionnels.component.html',
  styleUrl: './assurance-sante-professionnels.component.scss'
})
export class AssuranceSanteProfessionnelsComponent {
  title = 'Assurance Mutuelle Santé Professionnelle';
  subtitle = '';
  heroVideo = 'assets/videos/sante.mp4';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'Assurance Santé', link: undefined }
  ];

  prevPage = { title: 'Assurance des Personnes pour Particuliers',
    link: '/assurance-sante-particuliers'
  };

  nextPage = { title: 'Assurance Mutuelle Santé Internationale Professionnelle',
    link: '/assurance-mutuelle-sante-internationale-pro'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'ALPTIS', logo: 'assets/logos/ALPTIS.PNG' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'MALAKOFF HUMANIS', logo: 'assets/logos/MALAKOFF.PNG' },
    { name: 'HENNER', logo: 'assets/logos/HENNER.PNG' },
    { name: 'APIVIA', logo: 'assets/logos/APIVIA.PNG' },
    { name: 'AXA', logo: 'assets/images/logos/axa-logo.png' }
  ];

  constructor(private router: Router) {}

  navigateToComparison() {
    this.router.navigate(['/cac/comparaison']);
  }
}
